export const masonryWrapperIn = {
    "& .custom-card-text" : {
        '-webkit-line-clamp': 'unset',
        }
}